import ModalTemplate from "../../modals/ModalTemplate";
import { useAppStore } from "../../../../hooks/redux/app";
import { useCallback } from "react";

const GraceInfoModal = () => {
  const { app, showGraceModal } = useAppStore();

  const onShowModalClick = useCallback(
    (e) => {
      showGraceModal(false);
    },
    [app.showGraceModal]
  );

  if (!app.showGraceModal) {
    return null;
  }

  return (
    <ModalTemplate
      id={"grace-modal"}
      header={"Grace Period"}
      size={"md"}
      onClose={onShowModalClick}
    >
      <div className={"card-box"}>
        <div className={"card-body"}>
          <h4 className={"card-title"}>Grace Period</h4>
          <p>
            Your account is currently in a grace period because it was created
            before our new pricing model went into effect.
          </p>
          <p>
            ✅ <strong>What stays the same</strong>: Most of your existing usage
            limits will be <strong>grandfathered in</strong> — you won’t lose
            access to what you already have, even after the grace period ends.
          </p>
          <p>
            ⏳ <strong>What happens next</strong>: This grace period ends on{" "}
            <strong>October 15, 2025.</strong>
            After that, any new usage beyond your grandfathered limits will
            require a plan upgrade.
          </p>
          <p>
            🎁 <strong>Need more now?</strong> If you temporarily need to go
            over your current limits during this grace period, just contact{" "}
            <a href={"support@display.church"}>support</a>. We’re happy to offer
            a <strong>one-time bump</strong> to help ease the transition.
          </p>
        </div>
      </div>
    </ModalTemplate>
  );
};

export default GraceInfoModal;
